import { isDefined } from '@aloft/toolkit-shared';

import { CombinedColumn, SingleColumn, Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';
import { getValueForColumn } from './getValueForColumn.ts';

export const hasAnyValues =
  (
    getColumns: (pathPrefix: string) => (SingleColumn<'feature' | 'adjustment'> | CombinedColumn)[],
    pathPrefix: string,
  ) =>
  (summary: Tkv2PairedCostSummaryInterfaceV2, compId = 'subject') => {
    return getColumns(pathPrefix).some((col) => isDefined(getValueForColumn(summary, compId, col)));
  };
